import { render } from "./englishImproveIndex.vue?vue&type=template&id=f58305a2&scoped=true"
import script from "./englishImproveIndex.vue?vue&type=script&lang=js"
export * from "./englishImproveIndex.vue?vue&type=script&lang=js"

import "./englishImproveIndex.vue?vue&type=style&index=0&id=f58305a2&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f58305a2"]])

export default __exports__